module.exports = "img{\r\n    max-width:100%;\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/user-application/applicant-application/applicant-application.component.css
// module id = ./src/app/applicant/user-application/applicant-application/applicant-application.component.css
// module chunks = main